import React from "react";
import { Navigate } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./components/dashboard/Dashboard.js";
import { OverviewContent } from "./components/dashboard/Overview.jsx";
import { ReferralsContent } from "./components/dashboard/ReferralsContent.js";
import { WithdrawalsContent } from "./components/dashboard/Withdrawals.js";
import { Support } from "./components/dashboard/Support.js";
import { SignupForm, LoginForm } from "./components/Authentication/Authentication.jsx";
import PrivateRoute from "./components/dashboard/PrivateRoute.jsx";
// import Tasks from "./components/dashboard/Tasks/Tasks.jsx";
import Quiz from "./components/dashboard/Tasks/Quiz.jsx";
import Wheel from "./components/dashboard/Tasks/Wheel.jsx";
import InstructiveVideo from "./components/dashboard/Tasks/InstructiveVideo.jsx";
import FunnyVideo from "./components/dashboard/Tasks/FunnyVideo.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/auth" replace />} />

        {/* Routes Dashboard avec sous-routes */}

        {/* Route par défaut (login par ex.) */}
        <Route path="/auth" element={<Navigate to="/auth/login" replace />} />
        <Route path="/auth/signup" element={<SignupForm />} />
        <Route path="/auth/login" element={<LoginForm />} />

        {/* Routes du dashboard */}
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }>
          <Route index element={<OverviewContent />} />
          <Route path="overview" element={<OverviewContent />} />
          <Route path="referrals" element={<ReferralsContent />} />
          <Route path="withdrawals" element={<WithdrawalsContent />} />
          <Route path="support" element={<Support />} />
          <Route path="tasks" element={<Wheel />} />
          <Route path="tasks/quiz" element={<Quiz />} />
          <Route path="tasks/wheel" element={<Wheel />} />
          <Route path="tasks/videos/instructive" element={<InstructiveVideo />} />
          <Route path="tasks/videos/funny" element={<FunnyVideo />} />

          {/* 👇 REDIRECTION SI SOUS-ROUTE INCONNUE */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

      </Routes>
    </Router >
  );
}

export default App;
